export default __webpack_public_path__ + "static/media/tour_kupka.756200a0.jpg";